import { Component, OnInit,ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Title }     from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AspNetRolesService } from './asp-net-roles.service';
import { IAspNetRoles,AspNetRoles,SearchAspNetRoles,UserByRole } from './asp-net-roles';
declare var jQuery:any;

@Component({    
    selector: 'vnpt-asp-net-roles',
    templateUrl: 'asp-net-roles.component.html',
    providers:[AspNetRolesService]

})
export class AspNetRolesComponent implements OnInit {
    title:string = "Danh mục Nhóm quyền";
    listItems:AspNetRoles[] = [];
    detailItem:AspNetRoles;
    deleteItem:AspNetRoles;
    listUserByRole:UserByRole[] = [];
    saveStatusMessage:string="";
    saveStatus:boolean=true;
    idTinhThanh:number = this.auth.user.IdTinhThanh;

    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number;
    keyword: string = "";
    maxSize:number = 10;
    clickSubmitted:boolean = false;
    searchItems:SearchAspNetRoles = new SearchAspNetRoles();

    @ViewChild('myForm') myForm;
    
    Reset(){
        this.detailItem = new AspNetRoles({IdTinhThanh:this.auth.user.IdTinhThanh});        
        this.deleteItem= new AspNetRoles({IdTinhThanh:this.auth.user.IdTinhThanh});        
        this.clickSubmitted = false; 
    }
    btnSubmit(){
        this.clickSubmitted = true;
    }
    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }
    Save(){
        if(this.myForm.valid==true){
            this.saveStatusMessage ='Xin vui lòng đợi trong giây lát !';        
            jQuery("#loader").modal();            
            this.service.Save(this.detailItem)
                .subscribe((resp) => {
                    if (resp.Success){
                        this.GetListFromPagination(this.paging);
                        this.saveStatusMessage = "Lưu thành công!";
                        this.saveStatus = true;
                    }
                    else{
                        this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                });
            
            jQuery("#addModal").modal('hide');
            jQuery("#loader").modal();    
           
        }// End if check submit true
        else{
            console.log("chua luu");
        }
        
        
    }
    
    AnswerDelete(item:AspNetRoles){        
        this.deleteItem = item;
        jQuery("#modalConfirm").modal();
    }
    Delete(){
                
        this.deleteItem.TrangThai=0;
        this.service.Save(this.deleteItem)
            .subscribe((resp) => {
                if (resp.Success){
                    this.GetListFromPagination(this.paging);
                    this.saveStatusMessage = "Xoa thành công!";
                    this.saveStatus = true;
                }
                else{
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            });
        

    }

    GetListUserByRole(item:AspNetRoles){
        console.log(item);
        this.service.GetListUserByRole(this.idTinhThanh,item.Id,1,1,"")
        .subscribe(
        (data) => {
            
            this.listUserByRole = data;
           
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });
        jQuery('#listUserModal').modal({backdrop: 'static', keyboard: true}) ;
        
    }
    GetItem(item:AspNetRoles){

        this.service.GetItem(item.Id)
        .subscribe(
        (data) => {
            
            this.detailItem = data[0];
            console.log(this.detailItem);
            
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });
        jQuery("#addModal").modal();    
    }

    /*
    GetList() {                 
        this.service.GetList(this.idTinhThanh)
        .subscribe(
        (data) => {
            
            this.listItems = data;
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });
        
        
    }*/// GetList

    // Lấy danh sách từ Stored Procedure phân trang
    GetListFromPagination(paging: number) {

        //let pageSize = 10;
        console.log(this.keyword);
        this.service.GetListFromPagination(this.idTinhThanh, paging,this.maxSize, this.searchItems.keyword)
            .subscribe(
            (data) => {
                this.listItems = data;
                
                if (this.listItems.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (data[0]).TotalRows;
                    // tính tổng số trang cần phân dựa vào tổng records
                    this.totalPages = Math.ceil(this.totalCount / this.maxSize);
                   
                } else {
                    
                    if (paging > 1) {
                        this.GetListFromPagination(paging - 1);
                    } else {
                        console.log("ko co record");
                        this.totalPages = 0;
                    }
                }

                

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });

    }

    SearchChange(){                    
        this.GetListFromPagination(1);
    }

    constructor(private service: AspNetRolesService,
       private auth:AuthService,        
        private router: Router,
        private titleService: Title) {            
        this.Reset();
           
    }

    ngOnInit() {        
        this.titleService.setTitle(this.title);        
        this.GetListFromPagination(this.paging);
        
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/asp-net-roles/asp-net-roles.component.ts